import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

export enum CountryContext {
  RO = 'RO',
  HU = 'HU',
  BG = 'BG',
}

interface CountryContextResult {
  countryContext: CountryContext | undefined;
}

const useCountryContext = (
  allowRedirect: boolean = true,
): CountryContextResult => {
  const { countryCode } = useParams();
  const auth = useAuth();
  const navigate = useNavigate();

  const validCountries = [
    CountryContext.RO,
    CountryContext.HU,
    CountryContext.BG,
  ];
  if (
    allowRedirect &&
    auth.isAuthenticated &&
    (countryCode === undefined ||
      !validCountries.includes(countryCode.toUpperCase() as CountryContext))
  ) {
    navigate('/country-selection');
  }

  if (countryCode) {
    const context =
      CountryContext[countryCode.toUpperCase() as keyof typeof CountryContext];
    return {
      countryContext: context,
    };
  }

  return {
    countryContext: undefined,
  };
};

export default useCountryContext;
